import React from "react";
import styles from "./PropertyLegalStatements.scss";
import cx from "../utils/cx";
import { modal } from "./AsyncModal";
import PropertyLegalModal, { IPropertyLegalModalProps } from "./PropertyLegalModal";

export interface IPropertyLegalStatementsProps {
  className?: string;
  providerId?: number;
  hasLegalStatement?: boolean;
  hasPrivacyStatement?: boolean;
  hasCancellationPolicyStatement?: boolean;
}

type IStatementType = IPropertyLegalModalProps['statementType'];

const titlePerType: { [key in IStatementType]: string } = {
  legal: 'Impressum des Anbieters',
  privacy: 'Datenschutzerklärung des Anbieters',
  cancellation_policy: 'Widerrufsbelehrung des Anbieters'
}

const PropertyLegalStatements: React.FC<React.PropsWithChildren<IPropertyLegalStatementsProps>> = ({ className = '', providerId, hasLegalStatement, hasPrivacyStatement, hasCancellationPolicyStatement }) => {

  if (!providerId) return null;

  const showModal = (type: IStatementType) => () => {
    modal(
      <PropertyLegalModal statementType={type} providerId={providerId} />,
      { title: titlePerType[type], maxWidth: 'md' }
    ).then((res) => {
      console.debug('modal closed');
    }).catch((err) => {
      console.debug('modal closed');
    });
  }

  return <div className={cx(styles.propertyLegalStatements, className)}>
    {hasLegalStatement && <a onClick={showModal('legal')}>Impressum des Anbieters</a>}
    {hasPrivacyStatement && <a onClick={showModal('privacy')}>Datenschutzerklärung des Anbieters</a>}
    {hasCancellationPolicyStatement && <a onClick={showModal('cancellation_policy')}>Widerrufsbelehrung des Anbieters</a>}
  </div>
};



export default PropertyLegalStatements;
